// extracted by mini-css-extract-plugin
module.exports = {"Categories":"_2nSTQ","DesktopQuarters":"_2Q1AE","DesktopThirds":"_2Oqes","TabletThirds":"_2JDUD","TabletHalves":"_2_tld","Card":"_1hAcb","Spacing":"_1Tlwo"};